import React, { MouseEvent } from 'react';
import WelcomeHeaderDropdownButton from './WelcomeHeaderHomeDropdownButton';

interface RenderTopicsButtonProps {
  isVisible: boolean;
  onButtonClick: (
    event: MouseEvent<HTMLDivElement> | MouseEvent<HTMLButtonElement>,
  ) => void;
  dropdownText: React.ReactNode;
  buttonRef?: React.Ref<HTMLButtonElement> | null;
}

/**
 * Renders a dropdown button for toggling video topics in the welcome header.
 * Displays different button styles based on whether search results are open.
 */
const WelcomeHeaderTopicsDropdownButtonInner = ({
  isVisible,
  onButtonClick,
  dropdownText,
  buttonRef,
}: RenderTopicsButtonProps) => {
  return (
    <WelcomeHeaderDropdownButton
      ref={buttonRef}
      isVisible={isVisible}
      onClick={onButtonClick}
      data-testid="dashboard-view-all-topics-button"
      aria-haspopup="dialog"
    >
      {dropdownText}
    </WelcomeHeaderDropdownButton>
  );
};

const WelcomeHeaderTopicsDropdownButton = React.forwardRef<
  HTMLButtonElement,
  RenderTopicsButtonProps
>(({ ...props }, ref) => {
  const innerProps = { ...props, buttonRef: ref } as RenderTopicsButtonProps & {
    buttonRef?: React.Ref<HTMLButtonElement> | null;
  };
  // pass buttonRef down to the actual button components via prop forwarding
  return <WelcomeHeaderTopicsDropdownButtonInner {...innerProps} />;
});

export default WelcomeHeaderTopicsDropdownButton;
